import './RegistrationDisplayCard.scss';

import React from 'react';

const RegistrationDisplayCard = ({
  accountType,
  owners,
  headerPostText,
  sideBar,
  children
}) => {
  return (
    <div className="registration-display-card">
      <div className="header-level-data">
        <div className="account-info">
          <div className="account-type">
            {accountType} {headerPostText}
          </div>
          <div className="account-sub-info">
            <div className="account-owners blocked_data">
              {owners}
            </div>
          </div>
        </div>
        {sideBar &&
        <div className="side-bar">{sideBar}</div>
        }
      </div>
      {children}
    </div>
  );
};

export default RegistrationDisplayCard;
